export default {
  getLexique: (data) => {
    return data;
  },
};
